import React from 'react';

export const VaultIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12.9541 9.27273H17.3177C18.336 9.27273 18.8452 9.27273 19.2341 9.4709C19.5762 9.64521 19.8543 9.92336 20.0287 10.2655M3.86319 18.3636V4.90909C3.86319 3.89081 3.86319 3.38168 4.06136 2.99274C4.23568 2.65063 4.51382 2.37249 4.85594 2.19817C5.24487 2 5.75401 2 6.77228 2H10.045C11.0633 2 11.5724 2 11.9614 2.19817C12.3035 2.37249 12.5816 2.65063 12.7559 2.99274C12.9541 3.38168 12.9541 3.89081 12.9541 4.90909V11.6364M7.04501 5.63636H9.77228M7.04501 9.27273H9.77228M7.04501 12.9091H9.77228M2.9541 18.3636H12.045M17.045 17.2411L17.9541 18.1596L19.9996 16.0929M22.045 17.4707C22.045 19.7251 19.6114 21.3647 18.7259 21.8867C18.6253 21.946 18.575 21.9757 18.504 21.991C18.4488 22.003 18.3684 22.003 18.3133 21.991C18.2423 21.9757 18.192 21.946 18.0914 21.8867C17.2059 21.3647 14.7723 19.7251 14.7723 17.4707V15.2742C14.7723 14.907 14.7723 14.7234 14.8317 14.5656C14.8842 14.4262 14.9695 14.3018 15.0803 14.2031C15.2057 14.0915 15.3758 14.027 15.7161 13.8981L18.1533 12.9746C18.2478 12.9388 18.295 12.9209 18.3436 12.9138C18.3868 12.9075 18.4305 12.9075 18.4737 12.9138C18.5223 12.9209 18.5695 12.9388 18.664 12.9746L21.1012 13.8981C21.4415 14.027 21.6116 14.0915 21.737 14.2031C21.8477 14.3018 21.9331 14.4262 21.9856 14.5656C22.045 14.7234 22.045 14.907 22.045 15.2742V17.4707Z"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
